export default __webpack_public_path__ + "static/media/email-signup.0b25208d.svg";